export const subdivisions = {
  "subdivisions.getList": "subdivisions.getList",
  "subdivisions.create": "subdivisions.create",
  "subdivisions.edit": "subdivisions.edit",
  "subdivisions.delete": "subdivisions.delete",
} as const;
